<template>
    <div class="widget-contents DialogContent in-action-modal">
        <div class="widget-contents__inner DialogContentInner in-action-modal__container">
            <div class="in-action-modal__content">
                <VimeoPlayer
                    :videoId="videoId"
                    v-if="videoId"
                />
                <span
                    class="modal-close"
                    @click="closeSelf"
                >
                    <svg-rndr :width="16" :height="16" svg="close.svg" />
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import VimeoPlayer from '@C/VimeoPlayer';
import widgetMixin from '@M/widgets/dialog';

export default {
    name: 'SeeItInAction',
    created() {
        this.videoId = this._widgetInstance.privateSettings.videoId;
    },
    data() {
        return {
            videoId: false
        }
    },
    components: {
        VimeoPlayer
    },
    mixins: [widgetMixin]
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/stages/Widgets/SeeItInAction.vue